// src/hooks/useProcuringEntity.js
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import API from "../API";

const useProcuringEntity = (procuringEntityId) => {
  const [procuringEntityData, setProcuringEntityData] = useState(null);
  const [loading, setLoading] = useState(!!procuringEntityId);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProcuringEntity = async () => {
      if (!procuringEntityId) {
        setProcuringEntityData(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const response = await API.getProcuringEntity(procuringEntityId);
        setProcuringEntityData(response);
      } catch (err) {
        console.error('Error fetching procuring entity:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProcuringEntity();
  }, [procuringEntityId]);

  const entry = procuringEntityData || {};
  const data = entry?.data || null;

  const contract = data?.contract ?? null;
  const councilId = data?.council_id ?? null;
  const project = data?.project ?? null;
  const procuringEntity = data ?? null;

  return { project, procuringEntity, contract, councilId, loading, error };
};

const useSubProjects = (filterObj) => {
  const { subProjectsByKey, ensureSubProjects } = useContext(AppContext);

  useEffect(() => {
    ensureSubProjects(filterObj);
  }, [filterObj, ensureSubProjects]);

  const key = (() => {
    const pe = filterObj?.["filter[procuring_entity_id]"];
    if (pe != null) return `pe:${pe}`;
    try {
      const entries = Object.entries(filterObj || {}).sort(([a], [b]) => (a > b ? 1 : -1));
      return `sp:${JSON.stringify(entries)}`;
    } catch {
      return `sp:${String(filterObj)}`;
    }
  })();

  const entry = subProjectsByKey?.[key] || { data: [], loading: false, error: null };
  return { subProjects: entry.data, loading: entry.loading && !entry.data?.length, error: entry.error };
};

export  {useProcuringEntity, useSubProjects};